import en from "react-phone-number-input/locale/en.json";
import es from "react-phone-number-input/locale/es.json";
import fr from "react-phone-number-input/locale/fr.json";
import pt from "react-phone-number-input/locale/pt-BR.json";
export var defaultErrors = {
  invalidPhoneNumber: "Enter a valid phone number.",
  phoneNumberMissing: "Enter a phone number."
};
export var defaultForceShowError = {
  inlineError: false,
  outlineError: false
};
export var dictionaries = {
  en: en,
  es: es,
  fr: fr,
  pt: pt
};
export var DISPLAY_CLASS_NAME = "PhoneNumberInput";